export const makeApiUrl = (path: string): string =>
  `${window.config.connection.backendUrl}/api${path}`;

export const makeDeamonUrl = (path: string): string =>
  `${window.config.connection.daemonUrl}/api${path}`;
